<template>
  <div class="fileUploader">
    <div class="d-flex justify-content-between align-items-end">
      <label class="text-black">{{ title }}</label>
      <button
        class="ui-action-button"
        :disabled="isUpdating"
        @click="save"
      >
        {{ $t('global.saveChanges') }}
        <b-spinner class="ml-1" small label="loading" v-if="isUpdating"></b-spinner>
      </button>
    </div>
      <section class="section">
        <div class="input-container">
          <label>{{ $t("integrityCompliance.Carga") }}</label>
          <FileUploader
            :key="fileUploaderKey"
            :placeholder="$t('integrityCompliance.file_required')"
            :fileUrl="originalFile.file_url"
            type=".pdf"
            validate="pdf"
            :label="$t('global.browse')"
            @setFile="setFile"
          />
          <div class="ui-input-error-msg" v-if="$v.file.$error">{{ $t("global.inputs.required") }}</div>
        </div>
      </section>
  </div>
</template>

<script>
const FileUploader = () => import("@/components/FileUploader");
import { requiredIf } from "vuelidate/lib/validators";
import { ICfilesName } from "@/lib/constants.js";
import API_SERVICE from "@/lib/api/IntegrityCompliance.js";
const api = new API_SERVICE();

import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();

export default {
  inject: ['IC_getMainCategory'],
  props: {
    category: {
      type: String,
      default: ''
    },
    subcategory: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    files: {
      type: Array,
      default: () => []
    }
  },
  components: {
    FileUploader
  },
  computed: {
    originalFile() {
      let file = {};
      const files = this.files.filter(({ name }) => name === ICfilesName[this.category][this.subcategory])
      if (files.length) {
        file = files[files.length-1]
      }
      return file;
    }
  },
  data: function () {
    return {
      fileUploaderKey: new Date().getTime(),
      categoryData: {},
      file: null,
      isUpdating: false
    }
  },
  validations: {
    file: {
      required: requiredIf(function() {
        if (this.originalFile.file_url) {
          return false;
        } else {
          return true;
        }
      })
    }
  },
  mounted () {
    this.categoryData = this.IC_getMainCategory();
  },
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) return;
      try {
        this.isUpdating = true;

        if (this.file) { // file to upload
          const { Bucket, Key } = await this.uploadFile(this.file);
          const params = {
            name: ICfilesName[this.category][this.subcategory],
            description: ICfilesName[this.category][this.subcategory],
            srcBucket: Bucket,
            src: Key,
            category_id: this.categoryData.id,
          }

          if (this.originalFile.id) { // update file
            await api.updateDocument(this.originalFile.id, params);
          } else { // save new file
            const response = await api.createDocument(params);
            this.$emit('createdFile', response);
          }

          this.file = null;
          this.fileUploaderKey = `${this.subcategory}_fileUploader_${new Date().getTime()}`
        }

        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('global.successSaved'),
          show: true,
          type: "success"
        });
      } catch (error) {
        console.error(error);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('errors.file.upload'),
          show: true,
          type: "error"
        });
      } finally {
        this.isUpdating = false;
      }
    },
    setFile(file) {
      this.file = file;
      if (!file) {
        this.fileUploaderKey = `${this.subcategory}_fileUploader_${new Date().getTime()}`
      }
    },
    async uploadFile (file) {
      if (!file) return;
      try {
        const timestamp = Date.now();
        const response = await s3.uploadFile(
          `IC/${this.category}/${this.subcategory}/${timestamp}.pdf`,
          file
        );
        return response;
      } catch (error) {
        throw(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.fileUploader {
  width: 100%;
}

.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: $global_padding 0px;
  label {
      @extend %audi-b;
  }
}
</style>
